import deepAssign from 'deep-assign';

import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

import ButtonLink from '../common/ButtonLink';

import commonStyles from '../common/Styles';
// eslint-disable-next-line
const emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const styles = (theme) => {
  const common = commonStyles(theme);
  return deepAssign({}, common, {
    notes: {
      margin: '4px 24px 24px',
      textAlign: 'left',
      fontWeight: 400,
      fontSize: 14,
      color: 'rgba(0, 0, 0, 0.87)',
      lineHeight: 1.5,
      '&[data-error]': {
        color: theme.palette.error[500],
      },
    },
  });
};

class ResetPassword extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div
        className={classes.form}>
        {this.props.text.split('\n').map((item, key) => <p className={classes.text} key={key}>{item}</p>)}
        <p className={classes.text}>{this.props.linkHeader}</p>
        <div
          className={classes.actionButtons}>
          <ButtonLink
            className="to-right"
            color="secondary"
            variant="contained"
            to="/"
            onClick={this.props.onComplete}>Login</ButtonLink>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(ResetPassword)



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordComplete/index.js